import parse from 'html-react-parser';
import CtaButton from '../ctaButton/ctaButton';
import styles from './pagayaCard.module.scss';

export default function PagayaCard({
  brandImage,
  title,
  subTitle,
  description,
  ctaLabel,
  endNotes,
  ctaLink,
  ctaNavIcon,
  heapSelector,
}) {
  return (
    <div className={styles.cardsWrapper}>
      <img
        className={styles.pagayaLogo}
        data-testid={`${brandImage}-icon`}
        src={brandImage.url}
        alt={brandImage.alt}
        loading="lazy"
      />
      <div
        className={`${!description && styles.titleWrapperNoDescription} ${
          styles.titleWrapper
        }`}
      >
        <div className={styles.title}>
          <p>{parse(title)}</p>
        </div>
        <div className={styles.subTitle}>
          <p>{parse(subTitle)}</p>
        </div>
      </div>
      <div className={styles.inputWrapper}>
        <CtaButton
          href={ctaLink}
          label={`${ctaLabel}
          ${
            ctaNavIcon.url && (
              <img src={ctaNavIcon.url} alt={ctaNavIcon.alt} loading="lazy" />
            )
          }`}
          variant="tertiary"
          className={`${styles.button} ${heapSelector}`}
        />
      </div>
      <div className={styles.endNotes}>{parse(endNotes)}</div>
    </div>
  );
}
